import "./ScoreCard.scss";

import { HStack } from "Components/LabIZO/Stackizo";
import { ColorX } from "static";
import { HtmlParserWrapper } from "Components/HtmlParserWrapper";
import _ from "lodash";

const ScoreCard = ({ title, values, remarks }) => {
  if (values && !_.isString(values)) values = JSON.stringify(values);
  return (
    <div className="ScoreCard" style={{ background: ColorX.GetColorCSS("CardBG1") }}>
      <h3>{values && <HtmlParserWrapper html={values} />}</h3>
      <HStack width="100%">
        <p>{title && <HtmlParserWrapper html={title} />}</p>
        <p style={{ color: ColorX.GetColorCSS("Primary"), paddingLeft: 5 }}>{remarks && "  -  " + <HtmlParserWrapper html={remarks} />}</p>
      </HStack>
    </div>
  );
};

export default ScoreCard;
